import { ProductService } from 'src/app/angularJS/services/product/product.service';
import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';
import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';

export class ProductCopyController {

  public static $inject = ['$rootScope', '$state', '$stateParams', 'productService', 'UserMessages', 'ACTToolbarService'];
  public sourceProduct: InterACT.Interfaces.Catalogues.Product;
  public sourceCatalogue: InterACT.Interfaces.Catalogues.Catalogue;
  public isCalendarOpen: boolean;
  public showSpinner: boolean;
  public product: InterACT.Interfaces.Catalogues.Product;
  public productCopy: InterACT.Interfaces.Catalogues.Product;

  constructor(
    private $rootScope,
    private $state: ng.ui.IStateService,
    private $stateParams,
    private productService: ProductService,
    private UserMessages: UserMessagesService,
    private ActToolbarService: ACTToolbarService) {
    this.sourceCatalogue = $stateParams.sourceCatalogue;
    this.sourceProduct = $stateParams.sourceProduct;
    this.isCalendarOpen = false;
    this.showSpinner = false;
    this.product = <any>{
      name: ''
    };
    this.productCopy = angular.copy(this.sourceProduct);
    this.activate();
  }

  public copyProduct = () => {
    this.$rootScope.showSpinner = true;
    return this.productService.getProduct(this.sourceCatalogue.id, this.sourceProduct.id, {
      expand: true
    }).then((response) => {
      return this.productService.create(this.sourceCatalogue.id, angular.extend(response, this.product)).then(() => {
        this.$rootScope.showSpinner = false;
        this.UserMessages.showToast('TOAST_MESSAGE.PRODUCT.COPIED');
        this.exitProductCopy();
      });
    });
  }

  public exitProductCopy = () => {
    return this.$state.go('catalogue.product-list', {
      catalogueVersion: this.$stateParams.sourceCatalogue.version,
      catalogueId: this.$stateParams.sourceCatalogue.id
    });
  }

  public openCalendar = () => {
    return this.isCalendarOpen = true;
  }

  public isNameValid = (value: string) => {
    return this.productCopy.name !== value;
  }

  private activate() {
    this.ActToolbarService.getToolbar('primary').then((toolbar) => {
      toolbar.setTitle('Copy Product');
    });
  }
}